/* @flow */
import React, { Component } from 'react';
import {
  graphql,
  createPaginationContainer,
  type RelayPaginationProp,
} from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

import Well from '../../../components/Well';
import { Grid, Loader } from '../../../components';
import enhancer from '../../enhancer';

const styles = {
  toolbarButton: {
    padding: 5,
  },
};

const TOTAL = 10;

type Props = {} & RelayPaginationProp;

type State = {
  error: ?Error,
  loading: boolean,
};

class TutoringCompanies extends Component<Props, State> {
  state = {
    loading: false,
    error: null,
  };

  handleLoadMore = () => {
    this.setState({ loading: true });
    if (!this.props.relay.hasMore() || this.props.relay.isLoading()) {
      return;
    }

    this.props.relay.loadMore(
      TOTAL, // Fetch the next 10 feed items
      error => this.setState({ loading: false, error })
    );
  };

  handleEdit = (event, nodeId) => {
    this.props.history.push(`/admin/tutoring-company/${nodeId}`);
    event.preventDefault();
  };

  handleReload = () => {
    this.setState({ loading: true });
    this.props.relay.refetchConnection(TOTAL, error =>
      this.setState({ loading: false, error })
    );
  };
  s;

  handleCreate = event => {
    this.props.history.push('/admin/tutoring-company/create');
    event.preventDefault();
  };

  renderRow = ({ node }) => (
    <TableRow key={node.id}>
      <TableRowColumn>{node.name}</TableRowColumn>
      <TableRowColumn>{node.description}</TableRowColumn>
      <TableRowColumn>{node.referralCode}</TableRowColumn>
      <TableRowColumn>{node.internalMargin}</TableRowColumn>
      <TableRowColumn>{node.externalMargin}</TableRowColumn>
      <TableRowColumn>{node.studentCount}</TableRowColumn>
      <TableRowColumn>
        <RaisedButton
          primary
          label="Edit"
          onClick={event => this.handleEdit(event, node.id)}
        />
      </TableRowColumn>
    </TableRow>
  );

  render() {
    const { admin } = this.props;
    const { allTutoringCompanies } = admin;
    const { edges, pageInfo } = allTutoringCompanies;

    const { error, loading } = this.state;

    const headers = [
      'Name',
      'Description',
      'Referral Code',
      'Internal Margin',
      'External Margin',
      'Student Count',
      'Actions',
    ];

    return (
      <Well>
        {loading ? <Loader /> : null}
        {error && <div>{error.message}</div>}

        <Grid headers={headers} renderRow={this.renderRow} rows={edges} />

        <span style={styles.toolbarButton}>
          <RaisedButton
            disabled={!pageInfo.hasNextPage || loading}
            primary
            label="Load More"
            onClick={this.handleLoadMore}
          />
        </span>
        <span style={styles.toolbarButton}>
          <RaisedButton
            disabled={loading}
            secondary
            label="Reload"
            onClick={this.handleReload}
          />
        </span>
        <span style={styles.toolbarButton}>
          <RaisedButton
            disabled={loading}
            secondary
            label="Create"
            onClick={this.handleCreate}
          />
        </span>
      </Well>
    );
  }
}

const query = graphql`
  query TutoringCompaniesAdminQuery($count: Int!) {
    admin {
      ...TutoringCompanies_admin
    }
  }
`;

export default enhancer(TutoringCompanies, {
  relay: {
    query,
    variables: {
      count: 10,
    },
    create: () =>
      createPaginationContainer(
        TutoringCompanies,
        {
          admin: graphql`
            fragment TutoringCompanies_admin on Admin {
              allTutoringCompanies(first: $count)
                @connection(key: "TutoringCompanies_allTutoringCompanies") {
                edges {
                  node {
                    id
                    name
                    description
                    referralCode
                    internalMargin
                    externalMargin
                    studentCount
                  }
                }
              }
            }
          `,
        },
        {
          direction: 'forward',
          getConnectionFromProps(props) {
            return props.admin && props.admin.allTutoringCompanies;
          },
          getFragmentVariables(prevVars, totalCount) {
            return {
              ...prevVars,
              count: totalCount,
            };
          },
          getVariables(props, { count, cursor } /* , fragmentVariables */) {
            return {
              count,
              cursor,
              // in most cases, for variables other than connection filters like
              // `first`, `after`, etc. you may want to use the previous values.
              // orderBy: fragmentVariables.orderBy,
            };
          },
          query,
        }
      ),
  },
});



// WEBPACK FOOTER //
// ./src/modules/admin/company/TutoringCompanies.js